import React from 'react';

export const OneDriveSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-19.5"
				y="-23.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<path
				d="M13.3891 12.867L13.3894 12.8662L18.0077 15.6326L20.7598 14.4745C21.319 14.2327 21.922 14.1088 22.5312 14.1094C22.6327 14.1094 22.733 14.114 22.8329 14.1206C22.502 12.8305 21.8035 11.6642 20.8223 10.7635C19.8411 9.86286 18.6195 9.26656 17.3058 9.0471C15.9921 8.82765 14.6429 8.99448 13.4222 9.52732C12.2016 10.0602 11.1619 10.9361 10.4297 12.0486C10.4532 12.0484 10.4764 12.0469 10.5 12.0469C11.5207 12.0455 12.5214 12.3296 13.3891 12.867Z"
				fill="#0364B8"
			/>
			<path
				d="M13.3894 12.8664L13.3892 12.8671C12.5214 12.3297 11.5207 12.0456 10.5 12.047C10.4764 12.047 10.4532 12.0485 10.4297 12.0488C9.43071 12.0611 8.45396 12.3455 7.60443 12.8713C6.75489 13.3971 6.0647 14.1444 5.608 15.033C5.15131 15.9216 4.94539 16.9179 5.01237 17.9147C5.07935 18.9115 5.41669 19.8713 5.98816 20.6908L10.0609 18.9769L11.8714 18.215L15.9026 16.5186L18.0078 15.6327L13.3894 12.8664Z"
				fill="#0078D4"
			/>
			<path
				d="M22.8327 14.1208C22.7329 14.1141 22.6325 14.1095 22.531 14.1095C21.9218 14.1089 21.3189 14.2333 20.7597 14.4751L18.0076 15.6327L18.8056 16.1107L21.4215 17.6776L22.5628 18.3613L26.4653 20.6988C26.8199 20.0405 27.0036 19.3038 26.9997 18.5561C26.9958 17.8084 26.8044 17.0737 26.4429 16.4191C26.0815 15.7646 25.5616 15.2112 24.9308 14.8097C24.3001 14.4081 23.5787 14.1713 22.8327 14.1208Z"
				fill="#1490DF"
			/>
			<path
				d="M22.5626 18.3612L21.4213 17.6776L18.8054 16.1107L18.0074 15.6327L15.9022 16.5186L11.871 18.215L10.0605 18.9768L5.98779 20.6907C6.49391 21.4184 7.16861 22.0127 7.95428 22.4231C8.73996 22.8334 9.61327 23.0474 10.4996 23.0469H22.5309C23.3376 23.0472 24.1292 22.829 24.8219 22.4156C25.5146 22.0021 26.0824 21.4089 26.4651 20.6988L22.5626 18.3612Z"
				fill="#28A8EA"
			/>
		</svg>
	);
};
